import { text } from "d3";

let children = [];
//RestriccionAccesos
children.push({
    path: "/recursoshumanos/RestriccionAccesos",
    name: "HMN_ACCESS_RESTRICTION",
    component: () =>
        import("../views/HumanResource/AccessRestriction/AccessRestriction.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos  Humanos", disabled: true },
            {
                text: "Restricción de Accesos",
                href: "/recursoshumanos/RestriccionAccesos",
            },
        ],
        title: 'RH-Restricción de Accesos',
    },
});
//Historias
children.push({
    path: "/recursoshumanos/Salud_Ocupacional/Historias",
    name: "MEDICAL_RECORD",
    component: () =>
        import("../views/HumanResource/OccupationalHealth/HistoryRecord_G.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos  Humanos", disabled: true },
            { text: "Salud Ocupacional", disabled: true },
            {
                text: "Historias Médicas",
                href: "/recursoshumanos/Salud_Ocupacional/Historias",
            },
        ],
        title: 'RH-Historias Médicas',
    },
});
children.push({
    path: "/recursoshumanos/Salud_Ocupacional/Historias_Antiguas_Masivo",
    name: "MEDICAL_RECORD_MASSIVE",
    component: () =>
        import("../views/HumanResource/OccupationalHealth/HistoryLegacyMassive.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos  Humanos", disabled: true },
            { text: "Salud Ocupacional", disabled: true },
            {
                text: "Historias Antiguas - Carga Masiva",
                href: "/recursoshumanos/Salud_Ocupacional/Historias_Antiguas_Masivo",
            },
        ],
        title: 'RH-Historias Antiguas Masivo',
    },
});
//fotocheck
children.push({
    path: "/recursoshumanos/fotocheck",
    name: "FOTOCHECK",
    component: () =>
        import("../views/HumanResource/FotoCheck/FotoCheck.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Fotocheck", href: "/recursoshumanos/fotocheck" },
        ],
        title: 'RH-Fotocheck',
    },
});
children.push({
    path: "/recursoshumanos/qrGenerator",
    name: "HMN_QRGENERATOR",
    component: () =>
        import("../views/HumanResource/QRGenerator.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Generar QR", href: "/recursoshumanos/qrGenerator" },
        ],
        title: 'RH-Generar-QR',
    },
});

children.push({
    path: "/recursoshumanos/qrGeneratorGeneral",
    name: "HMN_QRGENERATOR_GENERAL",
    component: () =>
        import("../views/HumanResource/QRGeneratorProFixed.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Generador de QR General", href: "/recursoshumanos/qrGeneratorGeneral" },
        ],
        title: 'Generar-QR',
    },
});
//cargo
children.push({
    path: "/recursoshumanos/cargo",
    name: "GEN_POSITION",
    component: () =>
        import("../views/General/Position.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Cargo", href: "/recursoshumanos/cargo" },
        ],
        title: 'RH-Cargo',
    },
});
//organigrama
children.push({
    path: "/recursoshumanos/organigrama",
    name: "GEN_ORGANIZATION",
    component: () =>
        import("../views/General/Organization.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            {
                text: "Organigrama",
                href: "/recursoshumanos/organigrama",
            },
        ],
        title: 'RH-Organigrama',
    },
});
//programacion de accesos
children.push({
    path: "/recursoshumanos/programacionaccesos",
    name: "MNG_ACCESSPROGRAMMING",
    component: () =>
        import("../views/HumanResource/AccessProgramming.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            {
                text: "Programación de Accesos",
                href: "/recursoshumanos/programacionaccesos",
            },
        ],
        title: 'RH-Programación de Accesos',
    },
});
children.push({
    path: "/recursoshumanos/configuracion/reclutamiento",
    name: "HMN_RECRUITMENT_ACCESS",
    component: () =>
        import("../views/HumanResource/RecruitmentAccess.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento profesional", disabled: true },
            { text: "Permisos y asignaciones", href: "/recursoshumanos/configuracion/reclutamiento" },
        ],
        title: 'RH-Reclutamiento profesional',
    },
});
//reporte de horas
children.push({
    path: "/recursoshumanos/reporte_de_horas",
    name: "HMN_HOURS_REPORT",
    component: () =>
        import("../views/HumanResource/HoursReport.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            {
                text: "Reporte de Horas",
                href: "/recursoshumanos/reporte_de_horas",
            },
        ],
        title: 'RH-Reporte de Horas',
    },
});
//amonestaciones
children.push({
    path: "/recursoshumanos/amonestacion",
    name: "HMN_ADMONITION",
    component: () =>
        import("../views/HumanResource/Admonition.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Amonestaciones", href: "/recursoshumanos/amonestacion" },
        ],
        title: 'RH-Amonestaciones',
    },
});
//personal no sujetos a fiscalizacion
children.push({
    path: "/recursoshumanos/Personal_no_Sujetos_a_Ficalizacion",
    name: "HMN_PERSONNEL_NOT_SUBJECTS",
    component: () =>
        import("../views/HumanResource/PersonnelNotSubjects.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Personal no Sujetos a Ficalización", href: "/recursoshumanos/Personal_no_Sujetos_a_Ficalizacion" },
        ],
        title: 'RH-Personal no sujeto a Ficalización',
    },
});
//reporte de contratos
children.push({
    path: "/recursoshumanos/reporte_de_contratos",
    name: "HMN_CONTRACT_REPORT",
    component: () =>
        import("../views/HumanResource/ContractReport.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reporte de Contratos", href: "/recursoshumanos/reporte_de_contratos" },
        ],
        title: 'RH-Reporte de Contratos',
    },
});

children.push({
    path: "/recursoshumanos/reporte_de_inicio_arisunshine",
    name: "HMN_REPORT_START_ARISUNSHINE",
    component: () =>
        import("../views/HumanResource/AriSunshine/HmnReportAriStart.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "ARI Sunshine", disabled: true },
            { text: "Reporte de Registro", href: "/recursoshumanos/reporte_de_inicio_arisunshine" },
        ],
        title: 'RH-Reporte de Registro',
    },
});

children.push({
    path: "/recursoshumanos/consentimiento_digital",
    name: "HMN_DIGITAL_CONSENT_ARISUNSHINE",
    component: () =>
        import("../views/HumanResource/AriSunshine/HmnDigitalConsentAri.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "ARI Sunshine", disabled: true },
            { text: "Consentimiento Digital", href: "/recursoshumanos/consentimiento_digital" },
        ],
        title: 'RH-Consentimiento Digital',
    },
});

children.push({
    path: "/recursoshumanos/control_de_envios",
    name: "HMN_REPORT_PAYMENTS_CONFIRMED_ARISUNSHINE",
    component: () =>
        import("../views/HumanResource/AriSunshine/HmnReportPaySlipConfirm.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "ARI Sunshine", disabled: true },
            { text: "Control de Envios", href: "/recursoshumanos/control_de_envios" },
        ],
        title: 'RH-Control de Envios',
    },
});

//creacion de periodos
children.push({
    path: "/recursoshumanos/creacion_de_periodos",
    name: "HMN_CREATION_PERIODS",
    component: () =>
        import("../views/HumanResource/CreationPeriods.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Creación de Periodos", href: "/recursoshumanos/creacion_de_periodos" },
        ],
        title: 'RH-Creación de Periodos',
    },
});
//fotos de cumpleaños
children.push({
    path: "/recursoshumanos/fotos_happy_birthday",
    name: "HMN_BIRTHDAY",
    component: () =>
        import("../views/HumanResource/Birthday.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Fotos de Cumpleaños", href: "/recursoshumanos/fotos_happy_birthday" },
        ],
        title: 'RH-Fotos de Cumpleaños',
    },
});
//equipo biometrico
children.push({
    path: "/recursoshumanos/fotos_happy_birthday_month",
    name: "HMN_BIRTHDAY_MONTH",
    component: () =>
        import("../views/HumanResource/BirthdayMonth.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Fotos de Cumpleaños por Mes", href: "/recursoshumanos/fotos_happy_birthday_month" },
        ],
    },
});

children.push({
    path: "/recursoshumanos/equipo_biometrico",
    name: "HMN_BIOMETRIC_EQUIPMENT",
    component: () =>
        import("../views/HumanResource/BiometricEquipment.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Equipo Biométrico", href: "/recursoshumanos/equipo_biometrico" },
        ],
        title: 'RH-Equipo biométrico',
    },
});
//asignacion familiar
children.push({
    path: "/recursoshumanos/bienestarsocial/asignacionfamiliar",
    name: "HMN_HOUSEHOLDALLOWANCE",
    component: () =>
        import("../views/HumanResource/HouseHoldAllowance.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Bienestar Social", disabled: true },
            {
                text: "Asignación Familiar",
                href: "/recursoshumanos/bienestarsocial/asignacionfamiliar",
            },
        ],
        title: 'RH-Asignación Familiar',
    },
});
//contingencias laborales
children.push({
    path: "/recursoshumanos/bienestarsocial/contingeciaslaborales",
    name: "HMN_WORKERALLOWANCE",
    component: () =>
        import("../views/HumanResource/WorkerAllowance.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Bienestar Social", disabled: true },
            {
                text: "Contingencias Laborales",
                href: "/recursoshumanos/bienestarsocial/contingeciaslaborales",
            },
        ],
        title: 'RH-Contingencias Laborales',
    },
});
//registro de contratos
children.push({
    path: "/recursoshumanos/adminpersonal/registrotrabajadores",
    name: "CONTRCNS_CONTTO",
    component: () =>
        import("../views/HumanResource/contract.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Adm Personal", disabled: true },
            {
                text: "Registro de Trabajadores",
                href: "/recursoshumanos/adminpersonal/registrotrabajadores",
            },
        ],
        title: 'RH-Registro de Trabajadores',
    },
});
children.push({
    path: "/recursoshumanos/adminpersonal/firma-contrato",
    name: "CONTRCNS_CONTTO_SIGN",
    component: () =>
        import("../views/HumanResource/Contract/ContractSignView.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Adm Personal", disabled: true },
            {
                text: "Firma de Contrato",
                href: "/recursoshumanos/adminpersonal/firma-contrato",
            },
        ],
        title: 'RH-Firma de Contrato',
    },
});
children.push({
    path: "/recursoshumanos/adminpersonal/file-digital",
    name: "HMN_WORKER_DIGITAL_FILE",
    component: () =>
        import("../views/HumanResource/Contract/WorkerDigitalFileView.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Adm Personal", disabled: true },
            {
                text: "File Digital del Trabajador",
                href: "/recursoshumanos/adminpersonal/file-digital",
            },
        ],
        title: 'RH-File Digital del Trabajador',
    },
});
//reporte de asignacion familiar
children.push({
    path: "/recursoshumanos/bienestarsocial/reportesasignacionfamiliar",
    name: "HMN_HHA_REPORT",
    component: () =>
        import("../views/HumanResource/ReportHouseHoldWorker.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Bienestar Social", disabled: true },
            {
                text: "Reportes de Asignación Familiar",
                href: "/recursoshumanos/bienestarsocial/reportesasignacionfamiliar",
            },
        ],
        title: 'RH-Reportes de Asignación Familiar',
    },
});
//reportes
children.push({
    path: "/recursoshumanos/reportes",
    name: "HMN_REPORT_POSITION",
    component: () =>
        import("../views/HumanResource/ReportHumanResource.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Reportes", href: "/recursoshumanos/reportes" },
        ],
        title: 'RH-Reportes',
    },
});
//induccion de personal
children.push({
    path: "/recursoshumanos/sst/induccion",
    name: "SST_INDUCTION",
    component: () =>
        import("../views/Management/Instruction/New/InstructionNew.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "SST", disabled: true },
            {
                text: "Inducción de Personal",
                href: "/recursoshumanos/sst/induccion",
            },
        ],
        title: 'RH-Inducción de Personal',
    },
});
//induccion de personal - lista
children.push({
    path: "/recursoshumanos/sst/induccion_list_view",
    name: "SST_INDUCTION_LIST_VIEW",
    component: () =>
        import("../views/Management/Instruction/InstructionListView.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "SST", disabled: true },
            {
                text: "Lista de Inducción de Personal",
                href: "/recursoshumanos/sst/induccion_list_view",
            },
        ],
        title: 'RH-Inducción de Personal',
    },
});
//profesiones
children.push({
    path: "/recursoshumanos/mantenimiento/profesiones",
    name: "PFNSIONS",
    component: () =>
        import("../views/HumanResource/Profession.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Profesiones", disabled: true },
            {
                text: "Profesiones",
                href: "/recursoshumanos/mantenimiento/profesiones",
            },
        ],
        title: 'RH-Profesiones',
    },
});
//cuadrillas
children.push({
    path: "/recursoshumanos/mantenimiento/cuadrillas",
    name: "CDRILLS",
    component: () =>
        import("../views/HumanResource/hmnGang.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Cuadrillas", disabled: true },
            {
                text: "Profesiones",
                href: "/recursoshumanos/mantenimiento/cuadrillas",
            },
        ],
        title: 'RH-Profesiones',
    },
});
//asiento scire
children.push({
    path: "/recursoshumanos/compensaciones/AsientoScire",
    name: "HMN_JOURNALENTRY",
    component: () =>
        import("../views/HumanResource/JournalEntrySCIRE.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            {
                text: "Asiento SCIRE SAP",
                href: "/recursoshumanos/compensaciones/AsientoScire",
            },
        ],
        title: 'RH-Asiento SCIRESAP',
    },
});
//utilidades
children.push({
    path: "/recursoshumanos/utilidades",
    name: "UTILITY_SCHEDULING",
    component: () =>
        import("../views/Management/UtilityScheduling.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            {
                text: "Programación de Utilidades",
                href: "/recursoshumanos/utilidades",
            },
        ],
        title: 'RH-Programación de Utilidades',
    },
});
//vacunas
children.push({
    path: "/recursoshumanos/vaccine",
    name: "HMN_VACCINE",
    component: () =>
        import("../views/HumanResource/Vaccine/Vaccine.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            {
                text: "Registro de Vacunas",
                href: "/recursoshumanos/Vacunas",
            },

        ],
        title: 'RH-Registro de Vacunas',
    },
});

/// ------- Gestion Humnana
//programaciones
children.push({
    path: "/recursoshumanos/gestionhumana/programaciones",
    name: "HMN_INDUCTION_SCHEDULING",
    component: () =>
        import("../views/HumanResource/HumanManagement/InstructionScheduling.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "GESTIÍON HUMANA", disabled: true },
            {
                text: "Inducción de Personal",
                href: "/recursoshumanos/gestionhumana/programaciones",
            },
        ],
        title: 'RH-Inducción de Personal',
    },
});
//temas
children.push({
    path: "/administracion/temas",
    name: "MNG_INDUCTION_SUBJECT",
    component: () =>
        import("../views/Management/InstructionSubject.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Administración", disabled: true },
            { text: "Temas", href: "/administracion/temas" },
        ],
        title: 'RH-Temas',
    },
});
//induccion de personal - capacitaciones
children.push({
    path: "/recursoshumanos/gestionhumana/capacitaciones",
    name: "HMN_INDUCTION",
    component: () =>
        import("../views/HumanResource/HumanManagement/Instruction.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "GESTIÍON HUMANA", disabled: true },
            {
                text: "Capacitación de Personal",
                href: "/recursoshumanos/gestionhumana/capacitaciones",
            },
        ],
        title: 'RH-Capacitación de Personal',
    },
});
//preregistro de personal
children.push({
    path: "/recursoshumanos/preregistro",
    name: "HMN_PRE_REGISTRATION",
    component: () =>
        import("../views/HumanResource/PreRegistration/PreRegistration.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Pre Registro", disabled: true },
            {
                text: "Pre Registro del Personal",
                href: "/recursoshumanos/preregistro",
            },
        ],
        title: 'RH-Pre registro de Personal',
    },
});
//asignar bus
children.push({
    path: "/recursoshumanos/asignarbus",
    name: "HMN_ASSIGN_BUS_PERSON",
    component: () =>
        import("../views/HumanResource/BusControl/AssignBus.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Asignar Bus", disabled: true },
            {
                text: "Asignar Bus",
                href: "/recursoshumanos/asignarbus",
            },
        ],
        title: 'RH-Asignar Bus',
    },
});
//motivo de amonestacion
children.push({
    path: "/recursoshumanos/motivoamonestacion",
    name: "HMN_REASON_FOR_LIVELIHOOD",
    component: () =>
        import("../views/HumanResource/Admonition/ReasonForLivelihood.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Motivo de Amonestacion", disabled: true },
            {
                text: "Motivo de Amonestacion",
                href: "/recursoshumanos/motivoamonestacion",
            },
        ],
        title: 'RH-Motivo de Amonestacion',
    },
});
//manejo de bus
children.push({
    path: "/recursoshumanos/manejobuss",
    name: "HMN_BUSS",
    component: () =>
        import("../views/HumanResource/BusControl/Buss.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Manejo Buss", disabled: true },
            {
                text: "Manejo Buss",
                href: "/recursoshumanos/manejobuss",
            },
        ],
        title: 'RH-Manejo Bus',
    },
});
//preregistro de topico
children.push({
    path: "/recursoshumanos/preregistrotopico",
    name: "HMN_PRE_REGISTRATION_TOPIC",
    component: () =>
        import("../views/HumanResource/PreRegistration/PreRegistrationTopic.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Pre Registro Topico", disabled: true },
            {
                text: "Pre Registro del Personal",
                href: "/recursoshumanos/preregistrotopico",
            },
        ],
        title: 'RH-Pre registro de topico',
    },
});
//primer llamado
children.push({
    path: "/recursoshumanos/primerllamado",
    name: "RECRUITMENT_CALL",
    component: () =>
        import("../views/HumanResource/Recruitment/RecruitmentCall.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Mensaje de Texto", href: "/recursoshumanos/primerllamado" },
        ],
        title: 'RH-Mensaje de Texto',
    },
});
//feriados
children.push({
    path: "/recursoshumanos/feriados",
    name: "HMN_HOLIDAYS",
    component: () =>
        import("../views/HumanResource/Configuration/Holiday.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Configuración", disabled: true },
            {
                text: "Feriados",
                href: "/recursoshumanos/feriados",
            },
        ],
        title: 'RH-Feriados',
    },
});
//nivel educativo
children.push({
    path: "/recursoshumanos/niveleducativo",
    name: "HMN_EDUCATIONAL_LEVEL",
    component: () =>
        import("../views/HumanResource/EducationalLevel.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Nivel Educativo", href: "/recursoshumanos/niveleducativo" },
        ],
        title: 'RH-Nivel Educativo',
    },
});
//vacaciones
children.push({
    path: "/recursoshumanos/vacaciones",
    name: "HMN_VACATIONS",
    component: () =>
        import("../views/HumanResource/Vacations.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Vacaciones", href: "/recursoshumanos/vacaciones" },
        ],
        title: 'RH-Vacaciones',
    },
});
children.push({
    path: "/recursoshumanos/vacaciones/reporte_por_trabajador",
    name: "HMN_HISTORY_WORKER",
    component: () =>
        import("@/views/HumanResource/Vacations/HistoryWorker.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Vacaciones", disabled: true },
            { text: "Reporte por trabajador", href: "/recursoshumanos/vacaciones/reporte_por_trabajador" },
        ],
        title: 'RH-Reporte por trabajador',
    },
});
children.push({
    path: "/recursoshumanos/vacaciones/control_vacaciones",
    name: "HMN_VACATIONS_CONTROL",
    component: () =>
        import("@/views/HumanResource/Vacations/VacationsControl.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Vacaciones", disabled: true },
            { text: "Control de Vacaciones", href: "/recursoshumanos/vacaciones/control_vacaciones" },
        ],
        title: 'RH-Control de Vacaciones',
    },
});
children.push({
    path: "/recursoshumanos/vacaciones/reporte_vacaciones_gerencia",
    name: "HMN_VACATIONS_REPORT_MANAGEMENT",
    component: () =>
        import("@/views/HumanResource/Vacations/VacationsReportManagement.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Vacaciones", disabled: true },
            { text: "Reporte Gerencia", href: "/recursoshumanos/vacaciones/reporte_vacaciones_gerencia" },
        ],
        title: 'RH-Reporte Gerencia',
    },
});
//vacaciones aprobadas
children.push({
    path: "/recursoshumanos/vacaciones_aprobar",
    name: "HMN_VACATIONS_APPROVED",
    component: () =>
        import("../views/HumanResource/VacationsApproved.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Aprobar Vacaciones", href: "/recursoshumanos/vacaciones_aprobar" },
        ],
        title: 'RH-Aprobar Vacaciones',
    },
});
//visualizar vacaciones
children.push({
    path: "/recursoshumanos/visualizar_vacaciones",
    name: "HMN_VACATIONS_VIEW",
    component: () =>
        import("../views/HumanResource/VacationsView.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Visualizar Vacaciones", href: "/recursoshumanos/visualizar_vacaciones" },
        ],
        title: 'RH-Visualizar Vacaciones',
    },
});
//certificados
children.push({
    path: "/recursoshumanos/Certificaciones",
    name: "HMN_LIST_OF_CONTRACTS",
    component: () =>
        import("../views/HumanResource/ContractList/ContractList.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Certificados", href: "/recursoshumano/Certificaciones" },
        ],
        title: 'RH-Certificados',
    },
});
//horarios
children.push({
    path: "/recursoshumanos/compensaciones/horarios",
    name: "HMN_SCHEDULES",
    component: () =>
        import("../views/HumanResource/Schedules/Schedules.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Horarios", href: "/recursoshumanos/compensaciones/horarios" },
        ],
        title: 'RH-Horarios',
    },
});
//registro bajas
children.push({
    path: "/recursoshumanos/t-registro/bajas",
    name: "HMN_CASUALTYLIST",
    component: () =>
        import("../views/HumanResource/CasualtyList.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "T-Registro", disabled: true },
            { text: "Bajas", href: "/recursoshumano/t-registro/bajas" },
        ],
        title: 'RH-Bajas',
    },
});

//asignacion de trabajadores a equipo biometrico
children.push({
    path: "/recursoshumanos/AsignacionBiometrico",
    name: "HMN_BIOMETRIC_WORKER",
    component: () =>
        import("../views/HumanResource/AccessRestriction/BiometricWorker.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Adm. Personal", disabled: true },
            { text: "Asignación de Trabajador", href: "/recursoshumano/AsignacionBiometrico" },
        ],
        title: 'RH-Asignación de Trabajador',
    },
});
//fin asignacion de trabajadores a equipo biometrico
children.push({
    path: "/recursoshumanos/cambiarturnomasivo",
    name: "HMN_CHANGE_SHIFT",
    component: () =>
        import("../views/HumanResource/ChangeShiftMass.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Cambiar Turno Masivo", href: "/recursoshumanos/cambiarturnomasivo" },
        ],
        title: 'RH-Cambiar Turno Masivo',
    },
});
//configuracion de epps
children.push({
    path: "/recursoshumanos/sst/config_epps",
    name: "SST_CONFGEPPS",
    component: () =>
        import("../views/Management/Instruction/config_epps.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Config. Epps", disabled: true },
            {
                text: "Config. Epps",
                href: "/recursoshumanos/sst/config_epps",
            },
        ],
        title: 'RH-Config Epps',
    },
});
//regularizacion de marcaciones
children.push({
    path: "/recursoshumanos/compensaciones/regularizacion",
    name: "HMN_MARKING",
    component: () =>
        import("../views/HumanResource/Marking.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            {
                text: "Regularización",
                href: "/recursoshumanos/compensaciones/regularizacion",
            },
        ],
        title: 'RH-Regularización',
    },
});
//registro altas
children.push({
    path: "/recursoshumanos/t-registro/altas",
    name: "HMN_GENERATIONTXT",
    component: () =>
        import("../views/HumanResource/GenerationTxt.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "T-Registro", disabled: true },
            { text: "Altas", href: "/recursoshumanos/t-registro/altas" },
        ],
        title: 'RH-Altas',
    },
});
//registro de usuarios IPs
children.push({
    path: "/recursoshumanos/usrIP",
    name: "HMNUSRIP",
    component: () =>
        import("../views/HumanResource/UserIP.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "UsrIP", disabled: true },
            { text: "UsrIP", href: "/recursoshumanos/usrIP", },
        ],
        title: 'RH-Usuarios IP',
    },
});

//registro de usuarios IPs
children.push({
    path: "/recursoshumanos/parametros_distribucion",
    name: "HMN_DISTRIBUTION_PARAMETERS",
    component: () =>
        import("../views/HumanResource/DistributionControl.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Configuración", disabled: true },
            { text: "Parámetros de Distribución", href: "/recursoshumanos/parametros_distribucion", },
        ],
        title: 'RH-Parámetros de Distribución',
    },
});
//horario trabajador
children.push({
    path: "/recursoshumanos/compensaciones/horario-trabajador",
    name: "HMN_SCHEDULE_WORKER",
    component: () =>
        import("../views/HumanResource/Compensation/ScheduleWorker.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Horario-Trabajador", href: "/recursoshumanos/compensaciones/horario-trabajador" },
        ],
        title: 'RH-Horario de Trabajador',
    },
});
//asistencia remota
children.push({
    path: "/recursoshumanos/compensaciones/asistencia-remota",
    name: "HMN_ATTENDANCE_REMOTE",
    component: () =>
        import("../views/HumanResource/Compensation/AttendanceRemote.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Asistencia Remota", href: "/recursoshumanos/compensaciones/asistencia-remota" },
        ],
        title: 'RH-Asistencia Remota',
    },
});
//ficha de trabajador
children.push({
    path: "/recursoshumanos/fichatrabajador",
    name: "HMN_WORKER_TAB",
    component: () =>
        import("../views/HumanResource/WorkerTab/WorkerTab.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Ficha de Trabajador", href: "/recursoshumano/fichatrabajador" },
        ],
        title: 'RH-Ficha de Trabajador',
    },
});
//peligros SST
children.push({
    path: "/recursoshumanos/sst/peligros-sst",
    name: "SST_REGISTER_DANGER",
    component: () =>
        import("../views/HumanResource/Sst/DangerSST/DangerSST.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "SST", disabled: true },
            {
                text: "Peligros SST",
                href: "/recursoshumanos/sst/peligros-sst",
            },
        ],
        title: 'RH-Peligros de SST',
    },
});
//-----------Remote work-----------//
children.push({
    path: "/recursoshumanos/trabajo-remoto",
    name: "HMN_REMOTE_WORK",
    component: () =>
        import("../views/HumanResource/Compensation/RemoteWork.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Trabajo Remoto", href: "/recursoshumanos/trabajo-remoto" },
        ],
        title: 'RH-Trabajo Remoto',
    },
});
//-----------Massive print-----------//
children.push({
    path: "/recursoshumanos/impresion-masiva",
    name: "HMN_PRINT_MASIVE",
    component: () =>
        import("../views/HumanResource/PersonalManagement/MasivePrint.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Adm. Personal", disabled: true },
            { text: "Impresión Masiva", href: "/recursoshumanos/impresion-masiva" },
        ],
        title: 'RH-Impresión Masiva',
    },
});
//-----------Massive assistance gang-----------//
children.push({
    path: "/recursoshumanos/compensaciones/asistencia-masiva-gang",
    name: "HMN_MASSIVE_ASSISTANCE_GANG",
    component: () =>
        import("../views/HumanResource/Compensation/MassiveAssistanceGang.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Asistencia Masiva de Cuadrilla", href: "/recursoshumanos/compensaciones/asistencia-masiva-gang" },
        ],
        title: 'RH-Asistencia Masiva Cuadrilla',
    },
});
// Asignación masiva de feriado
children.push({
    path: "/recursoshumanos/compensaciones/feriado-masivo",
    name: "HMN_HOLIDAY_MASSIVE",
    component: () => import("../views/HumanResource/Compensation/HolidayMassive.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Asignación Masiva de Feriado", href: "/recursoshumanos/compensaciones/feriado-masivo" },
        ],
        title: 'RH-Asignación Masiva de Feriado',
    },
});
children.push({
    path: "/recursoshumanos/marcaciones",
    name: "HMN_MARKINGS",
    component: () =>
        import("../views/HumanResource/Attendance/Markings.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Asistencia", disabled: true },
            { text: "Marcaciones", href: "/recursoshumanos/marcaciones" },
        ],
        title: 'RH-Marcaciones',
    },
});
//-----------Documentacion-----------//
children.push({
    path: "/recursoshumanos/docs",
    name: "HMN_DOCS",
    component: () =>
        import("../views/Documentation/RRHHDoc.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Docs", disabled: true },
            //{ text: "Asistencia Masiva de Cuadrilla", href: "/recursoshumanos/compensaciones/asistencia-masiva-gang"},
        ],
        title: 'RH-Docs',
    },
});
children.push({
    path: "/recursoshumanos/compensaciones/approvalAssistanceRemote",
    name: "HMN_APPROVAL_ATTENDANCE_REMOTE",
    component: () =>
        import("../views/HumanResource/Compensation/ApprovalAttendanceRemote.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Aprobación de asistencia remota", href: "/recursoshumanos/compensaciones/approvalAssistanceRemote" },
        ],
        title: 'Aprobación de asistencia remota',
    },
});
children.push({
    path: "/recursoshumanos/compensaciones/validationAssistanceRemote",
    name: "HMN_VALIDATION_REQUEST_REMOTE",
    component: () =>
        import("../views/HumanResource/Compensation/ValidationAttendanceRemote.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Aprobación de trabajo remoto", href: "/recursoshumanos/compensaciones/validationAssistanceRemote" },
        ],
        title: 'Aprobación de trabajo remoto',
    },
});
children.push({
    path: "/recursoshumanos/reportes/horasTrabajadas",
    name: "HMN_HOURS_WORKED",
    component: () =>
        import("../views/HumanResource/Reports/HoursWorked.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Reportes", disabled: true },
            { text: "Horas Trabajadas", href: "/recursoshumanos/reportes/horasTrabajadas" },
        ],
        title: 'Horas Trabajadas',
    },
});
children.push({
    path: "/recursoshumanos/reportes/reporte_distribucion",
    name: "HMN_DISTRIBUTION_REPORT",
    component: () =>
        import("../views/HumanResource/Reports/DistributionReport.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Reportes", disabled: true },
            { text: "Reporte de Distribución", href: "/recursoshumanos/reportes/reporte_distribucion" },
        ],
        title: 'Reporte de Distribución',
    },
});
children.push({
    path: "/recursoshumanos/reportes/reporte_horas_diarias",
    name: "HMN_DAILY_HOURS_REPORT",
    component: () =>
        import("../views/HumanResource/Reports/DailyHoursReport.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Reportes", disabled: true },
            { text: "Reporte de Horas Diarias", href: "/recursoshumanos/reportes/reporte_horas_diarias" },
        ],
        title: 'Reporte de Horas Diarias',
    },
});
children.push({
    path: "/recursoshumanos/reportes/consolidado_marcaciones",
    name: "HMN_QUANTITY_MARKINGS_REPORT",
    component: () =>
        import("../views/HumanResource/Reports/ConsolidatedMarking.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Reportes", disabled: true },
            { text: "Consolidado Marcaciones", href: "/recursoshumanos/reportes/consolidado_marcaciones" },
        ],
        title: 'Consolidado Marcaciones',
    },
});
children.push({
    path: "/recursoshumanos/reportes/listadoMarcaciones",
    name: "HMN_MARKING_LIST_REPORT",
    component: () =>
        import("../views/HumanResource/Reports/MarkingList.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Reportes", disabled: true },
            { text: "Listado de Marcaciones", href: "/recursoshumanos/reportes/listadoMarcaciones" },
        ],
        title: 'Listado de Marcaciones',
    },
});
children.push({
    path: "/recursoshumanos/compensaciones/regularizacion-masiva",
    name: "HMN_MARKINGS_MASSIVE",
    component: () =>
        import("../views/HumanResource/Compensation/MarkingMassive.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Compensaciones", disabled: true },
            { text: "Regularización Masiva", href: "/recursoshumanos/compensaciones/regularizacion-masiva" },
        ],
        title: 'Regularización Masiva',
    },
});
children.push({
    path: "/recursoshumanos/reportes/reporte_consolidado_marcaciones",
    name: "HMN_REPORT_CONSOLIDATED_MARKINGS",
    component: () =>
        import("../views/HumanResource/Reports/ReportConsolidatedMarking.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reportes", disabled: true },
            { text: "Reporte Consolidado Marcaciones", href: "/recursoshumanos/reportes/reporte_consolidado_marcaciones" },
        ],
        title: 'Reporte Consolidado Marcaciones',
    },
});
children.push({
    path: "/recursoshumanos/estructura_organizacional/occupationalgroup",
    name: "HMN_OCCUPATIONAL_GROUP",
    component: () =>
        import("../views/HumanResource/OrganizationalStructure/HmnOccupationalGroup.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Estructura Organizacional", disabled: true },
            { text: "Grupo Ocupacional", href: "/recursoshumanos/estructura_organizacional/occupationalgroup" },
        ],
        title: 'Grupo Ocupacional',
    },
});
// Nuevo: fotocheck Evolis
children.push({
    path: "/recursoshumanos/fotocheck-evolis",
    name: "FOTOCHECK_EVOLIS",
    component: () => import("../views/HumanResource/FotoCheck/CardPrintPanel.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Fotocheck Evolis", href: "/recursoshumanos/fotocheck-evolis" },
        ],
        title: 'RH-Fotocheck Evolis',
    },
});
// historias medicas validadas en tiempo real
children.push({
    path: "/recursoshumanos/adm_personal/aptitud_medica",
    name: "HMN_HISTORY_REAL_TIME",
    component: () =>
        import("../views/HumanResource/OccupationalHealth/HistoryRealTime.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos  Humanos", disabled: true },
            { text: "Adm Personal", disabled: true },
            {
                text: "Aptitud Médica",
                href: "/recursoshumanos/adm_personal/aptitud_medica",
            },
        ],
        title: 'RH-Aptitud Médica',
    },
});

// contratos previos
children.push({
    path: "/recursoshumanos/contratos-previos",
    name: "HMN_PREVIOUS_CONTRACT",
    component: () => import("../views/HumanResource/PreviousContract/PreviousContract.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos  Humanos", disabled: true },
            { text: "Contratos Previos", href: "/recursoshumanos/contratos-previos" },
        ],
        title: 'RH-Contratos Previos',
    },
});
//------- Final Gestion Humana
//reclutamiento - requerimientos
children.push({
    path: "/recursoshumanos/reclutamiento/requerimientos",
    name: "HMN_STAFFING_REQUIREMENT",
    component: () =>
        import("../views/HumanResource/Recruitmentseleccion/HmnStaffingRequirement.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento", disabled: true },
            {
                text: "Requerimientos",
                href: "/recursoshumanos/reclutamiento/requerimientos",
            },
        ],
        title: "RH-Requerimientos de Personal",
    },
});
//reclutamiento - convocatorias profesionales
children.push({
    path: "/recursoshumanos/reclutamiento/convocatorias",
    name: "HMN_RECRUITMENT_PROCESS",
    component: () =>
        import("../views/HumanResource/RecruitmentProcess/HmnRecruitmentProcess.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento", disabled: true },
            {
                text: "Convocatorias",
                href: "/recursoshumanos/reclutamiento/convocatorias",
            },
        ],
        title: "RH-Convocatorias Profesionales",
    },
});
children.push({
    path: "/recursoshumanos/gestionhumana/promociones",
    name: "HMN_PROMOTION_PROCESS",
    component: () =>
        import("../views/HumanResource/RecruitmentProcess/HmnPromotionProcess.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Gestión Humana", disabled: true },
            {
                text: "Promociones Internas",
                href: "/recursoshumanos/gestionhumana/promociones",
            },
        ],
        title: "RH-Promociones Internas",
    },
});
//reclutamiento - aprobación de candidatos por jefe
children.push({
    path: "/recursoshumanos/reclutamiento/aprobaciones",
    name: "HMN_BOSS_APPROVAL",
    component: () =>
        import("../views/HumanResource/RecruitmentProcess/HmnBossApprovalSCRUD.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento", disabled: true },
            {
                text: "Aprobación de Candidatos",
                href: "/recursoshumanos/reclutamiento/aprobaciones",
            },
        ],
        title: "RH-Aprobación de Candidatos",
    },
});
//reclutamiento - convocatoria masiva
children.push({
    path: "/recursoshumanos/reclutamiento/convocatoria-masiva",
    name: "HMN_MASSIVE_RECRUITMENT",
    component: () =>
        import("../views/HumanResource/RecruitmentMassive/HmnMassiveRecruitment.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento", disabled: true },
            {
                text: "Convocatoria masiva",
                href: "/recursoshumanos/reclutamiento/convocatoria-masiva",
            },
        ],
        title: "RH-Convocatoria Masiva",
    },
});
children.push({
    path: "/recursoshumanos/reclutamiento/asistencia-convocatoria",
    name: "HMN_MASSIVE_RECRUITMENT_ATTENDANCE",
    component: () =>
        import("../views/HumanResource/RecruitmentMassive/HmnRecruitmentAttendance.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento", disabled: true },
            {
                text: "Asistencia Convocatoria",
                href: "/recursoshumanos/reclutamiento/asistencia-convocatoria",
            },
        ],
        title: "RH-Asistencia Convocatoria",
    },
});
children.push({
    path: "/recursoshumanos/utilidades-rrhh",
    name: "HMN_UTILITIES",
    component: () =>
        import("../views/HumanResource/Utilities/Utilities.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Utilidades", href: "/recursoshumanos/utilidades-rrhh" },
        ],
        title: 'RH-Utilidades',
    },
});
//Documentos por Puesto
children.push({
    path: "/recursoshumanos/documentos-por-puesto",
    name: "HMN_POSITION_DOCUMENT",
    component: () =>
        import("../views/HumanResource/DocumentosPosition/HmnPositionDocument.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Documentos por Puesto", href: "/recursoshumanos/documentos-por-puesto" },
        ],
        title: 'RH-Documentos por Puesto',
    },
});
//historial de auditorias
children.push({
    path: "/recursoshumanos/historial-auditorias",
    name: "HMN_AUDIT_HISTORY",
    component: () =>
        import("../views/HumanResource/Audit/AuditView.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Historial de Auditorías", href: "/recursoshumanos/historial-auditorias" },
        ],
        title: 'RH-Historial de Auditorías',
    },
});
children.push({
    path: "/recursoshumanos/reclutamiento/carga-masiva-dni",
    name: "HMN_RECRUITMENT_MASSIVE_DNI",
    component: () =>
        import("../views/HumanResource/RecruitmentProcess/HmnRecruitmentMassiveDni.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento", disabled: true },
            {
                text: "Carga masiva por DNI",
                href: "/recursoshumanos/reclutamiento/carga-masiva-dni",
            },
        ],
        title: "RH-Carga Masiva por DNI",
    },
});
children.push({
    path: "/recursoshumanos/reclutamiento/carga-masiva-dni-masivo",
    name: "HMN_RECRUITMENT_MASSIVE_DNI_SELECTION",
    component: () =>
        import("../views/HumanResource/RecruitmentMassive/HmnRecruitmentMassiveDniSelection.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento", disabled: true },
            {
                text: "Carga masiva por DNI (Campaña)",
                href: "/recursoshumanos/reclutamiento/carga-masiva-dni-masivo",
            },
        ],
        title: "RH-Carga Masiva por DNI (Campaña)",
    },
});
children.push({
    path: "/recursoshumanos/reclutamiento/mis-procesos-masivos",
    name: "HMN_MY_MASSIVE_RECRUITMENT",
    component: () =>
        import("../views/HumanResource/RecruitmentMassive/HmnMyMassiveRecruitment.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Reclutamiento", disabled: true },
            { text: "Mis Procesos Masivos", href: "/recursoshumanos/reclutamiento/mis-procesos-masivos" },
        ],
        title: 'RH-Mis Procesos Masivos',
    },
});

// Instituciones Educativas
children.push({
    path: "/recursoshumanos/Configuraciones/instituciones_educativas",
    name: "HMN_EDUCATIONAL_INSTITUTION",
    component: () => import("../views/HumanResource/HmnEducationalInstitution/HmnEducationalInstitution.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Configuraciones", disabled: true },
            { text: "Instituciones Educativas", href: "/recursoshumanos/Configuraciones/instituciones_educativas" },
        ],
    },
});

// Carreras Educativas
children.push({
    path: "/recursoshumanos/Configuraciones/carreras_educativas",
    name: "HMN_EDUCATIONAL_MAJOR",
    component: () => import("../views/HumanResource/HmnEducationalMajor/HmnEducationalMajor.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Configuraciones", disabled: true },
            { text: "Carreras Educativas", href: "/recursoshumanos/Configuraciones/carreras_educativas" },
        ],
    },
});

// Establecimientos (Plantas)
children.push({
    path: "/recursoshumanos/Configuraciones/establecimientos",
    name: "HMN_ESTABLISHMENT",
    component: () => import("../views/HumanResource/HmnEstablishment/HmnEstablishment.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Configuraciones", disabled: true },
            { text: "Establecimientos", href: "/recursoshumanos/Configuraciones/establecimientos" },
        ],
    },
});
// Demo Módulo Contratos V2
children.push({
    path: "/recursoshumanos/Contratos/DemoDatosPersonales",
    name: "CONTRACT_PERSONAL_DEMO",
    component: () => import("../views/HumanResource/Contract/PersonalDataDemo.vue"),
    meta: {
        authenticated: true,
        title: 'RH-Demo Datos Personales',
    },
});
children.push({
    path: "/recursoshumanos/adminpersonal/kiosco-firma",
    alias: ["/recursoshumanos/adminpersonal/terminal-firma", "/recursoshumanos/kiosco-firma"],
    name: "HMN_SIGNING_KIOSK",
    component: () =>
        import("../views/HumanResource/Contract/DocumentSigningKioskView.vue"),
    meta: {
        authenticated: true,
        fullScreenLayout: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Adm Personal", disabled: true },
            {
                text: "Terminal de Firma Digital",
                href: "/recursoshumanos/adminpersonal/terminal-firma",
            },
        ],
        title: 'RH-Terminal de Firma',
    },
});
children.push({
    path: "/recursoshumanos/turnero-kiosko",
    alias: ["/recursoshumanos/turnos-tv", "/recursoshumanos/turnero-terminal"],
    name: "HMN_TURNERO_KIOSKO",
    component: () =>
        import("../views/HumanResource/Contract/ContractTurnDisplayView.vue"),
    meta: {
        authenticated: true,
        fullScreenLayout: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Turnero Terminales", disabled: true },
            {
                text: "Pantalla de Turnos",
                href: "/recursoshumanos/turnero-kiosko",
            },
        ],
        title: 'RH-Pantalla de Turnos Terminal',
    },
});
children.push({
    path: "/recursoshumanos/adminpersonal/contrato-masivo",
    name: "HMN_CONTRACT_MASSIVE",
    component: () =>
        import("../views/HumanResource/Contract/ContractMassiveAdd.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Adm Personal", disabled: true },
            {
                text: "Contratos Masivos",
                href: "/recursoshumanos/adminpersonal/contrato-masivo",
            },
        ],
        title: 'RH-Contratos Masivos',
    },
});

children.push({
    path: "/recursoshumanos/evaluacion/campanas",
    name: "HMN_EVALUATION_CAMPAIGNS",
    component: () =>
        import("../views/HumanResource/Evaluation/EvaluationCampaign.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Evaluación de Desempeño", disabled: true },
            {
                text: "Campañas de Evaluación",
                href: "/recursoshumanos/evaluacion/campanas",
            },
        ],
        title: 'RH-Campañas de Evaluación',
    },
});

children.push({
    path: "/recursoshumanos/evaluacion/mis-evaluaciones",
    name: "HMN_MY_PENDING_EVALUATIONS",
    component: () =>
        import("../views/HumanResource/Evaluation/MyPendingEvaluations.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Recursos Humanos", disabled: true },
            { text: "Evaluación de Desempeño", disabled: true },
            {
                text: "Mis Evaluaciones Pendientes",
                href: "/recursoshumanos/evaluacion/mis-evaluaciones",
            },
        ],
        title: 'RH-Mis Evaluaciones Pendientes',
    },
});
export { children }